import clsx from 'clsx';
import { useRef } from 'react';

interface UploadContainerProps {
	id: string;
	children: React.ReactNode;
	disabled?: boolean;
	file?: File;
	setFile: (value: File) => void;
	accept?: string;
}

export const UploadContainer: React.FC<UploadContainerProps> = ({
	id,
	children,
	disabled,
	setFile,
	accept,
}) => {
	const fileInputRef = useRef(null);

	const handleMediaUpload = (file: File): void => {
		if (file) {
			const reader = new FileReader();
			reader.onload = function (e) {
				const uploadedObj = { file, url: e.target?.result as string };
				setFile(uploadedObj.file);
			};
			reader.readAsDataURL(file); // convert to base64 string
		}

		// Reset the input value
		if (fileInputRef.current) {
			(fileInputRef.current as any).value = null;
		}
	};
	return (
		<>
			<input
				type="file"
				id={'upload-media-' + id}
				name={'upload-media-' + id}
				multiple={false}
				className="sr-only peer"
				ref={fileInputRef}
				onChange={(event) => {
					if (disabled) return;
					event.target.files ? handleMediaUpload(event.target.files[0]) : null;
				}}
				accept={accept}
			/>
			<label
				htmlFor={'upload-media-' + id}
				className={clsx(
					'rounded-full peer-focus-visible:ring-2 peer-focus-visible:ring-primary peer-focus-visible:ring-offset-2',
					{ 'cursor-not-allowed pointer-events-none': disabled }
				)}
			>
				{children}
			</label>
		</>
	);
};
